import React, { useState, useEffect, FC } from "react";
import Content from "../../layout/content/Content";
import { Card, Row, Col, Button, Spinner } from "reactstrap";
import {
  TableColumnsType,
  Table,
  Progress,
  Select,
  Input,
  Flex,
  Spin,
  Empty,
  Tooltip,
  Drawer,
  Modal,
  Form,
  Space,
  Tag,
  Alert,
  Descriptions,
  Timeline,
  Divider,
  DatePicker,
  Button as AntButton,
  Statistic,
} from "antd";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  TooltipComponent,
} from "../../components/Component";
import FormatDate from "../masters/DateFormater";
import {
  SearchOutlined,
  InfoCircleOutlined,
  EyeOutlined,
  CheckOutlined,
  CloseOutlined,
  ReloadOutlined,
  FileTextOutlined,
  DollarOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import Swal from "sweetalert2";
import { useLocation, useNavigate, useParams } from "react-router";
import statusMapper from "./StatusMapper";
import dispatchApis from "../../api/dispatch/dispatch";
import PaymentsAside from "./PaymentsAside";
import { formatCurrency, formatCurrency2 } from "../../utils/Utils";
import usersApis from "../../api/master/users";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";
import dayjs from "dayjs";
import { PaymentData, PaymentStatus, UserRole, PaymentFilters } from "./types";
import {
  mockPaymentData,
  getPaymentsForApproval,
} from "./mockData/paymentData";
import {
  mockContractorOptions,
  mockSiteOptions,
} from "./mockData/approvedRaBillsData";
import paymentsApis from "../../api/WorkOrderManagement/PaymentsApis";
const { Option } = Select;
interface WidgetData {
  title: string;
  count: number;
  progress: number;
  color: string;
}

const PendingPaymentApprovals: FC = () => {
  const location = useLocation();
  const id = location?.state?.id;
  console.log("id------", id);

  const [disableAccept, setDisableAccept] = useState<boolean>(false);
  const [disableReject, setDisableReject] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);

  const [sm, setSm] = useState(false);
  const navigate = useNavigate();
  const [viewDrawer, setViewDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState<any>(null);
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [currentUserId, setCurrentUserId] = useState<any>(null);
  const [approverIds, setApproverIds] = useState<any>([]);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [refreshToggle, setRefreshToggle] = useState(false);

  // New payment approvals state
  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState<PaymentData[]>([]);
  const [filteredPayments, setFilteredPayments] = useState<PaymentData[]>([]);
  const [selectedPayment, setSelectedPayment] = useState<any>(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalAction, setApprovalAction] = useState<"approve" | "reject">(
    "approve"
  );
  const [approvalComments, setApprovalComments] = useState("");
  const [actionLoading, setActionLoading] = useState(false);

  // Filters
  const [filters, setFilters] = useState<PaymentFilters>({});
  const [searchText, setSearchText] = useState("");

  // Mock current user role - this would come from authentication context
  const [currentUserRole] = useState<UserRole>(UserRole.Approver);
  useEffect(() => {
    if (showRejectModal == false) {
      setDisableReject(false);
    }
  }, [showRejectModal]);

  useEffect(() => {
    if (id) {
      setViewDrawer(true);
    }
  }, [id]);

  // New useEffect hooks for payment approvals
  useEffect(() => {
    loadPaymentsForApproval();
  }, [currentUserRole, refreshToggle]);

  useEffect(() => {
    applyFilters();
  }, [payments, filters, searchText]);

  const loadPaymentsForApproval = async () => {
    try {
      setLoading(true);

      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Get payments pending approval for current user role
      const pendingPayments = getPaymentsForApproval(currentUserRole);
      setPayments(pendingPayments);
    } catch (error) {
      console.error("Error loading payments:", error);
      Swal.fire("Error!", "Failed to load payments", "error");
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...payments];

    // Apply search text filter
    if (searchText) {
      filtered = filtered.filter(
        (payment) =>
          payment.paymentVoucherNumber
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          payment.contractorName
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          payment.siteName.toLowerCase().includes(searchText.toLowerCase()) ||
          payment.allocations.some(
            (alloc) =>
              alloc.raBillNumber
                ?.toLowerCase()
                .includes(searchText.toLowerCase()) ||
              alloc.workOrderNumber
                ?.toLowerCase()
                .includes(searchText.toLowerCase())
          )
      );
    }

    // Apply date range filters
    if (
      filters.submissionDateRange &&
      filters.submissionDateRange[0] &&
      filters.submissionDateRange[1]
    ) {
      filtered = filtered.filter((payment) => {
        if (!payment.submittedAt) return false;
        const submitDate = dayjs(payment.submittedAt);
        return (
          submitDate.isAfter(filters.submissionDateRange![0]) &&
          submitDate.isBefore(filters.submissionDateRange![1])
        );
      });
    }

    // Apply contractor filter
    if (filters.contractorIds && filters.contractorIds?.length > 0) {
      filtered = filtered.filter((payment) =>
        filters.contractorIds!.includes(payment.contractorId)
      );
    }

    // Apply site filter
    if (filters.siteIds && filters.siteIds?.length > 0) {
      filtered = filtered.filter((payment) =>
        filters.siteIds!.includes(payment.siteId)
      );
    }

    // Apply amount range filter
    if (filters.amountRange) {
      filtered = filtered.filter(
        (payment) =>
          payment.netPayable >= (filters.amountRange!.min || 0) &&
          payment.netPayable <= (filters.amountRange!.max || Infinity)
      );
    }

    setFilteredPayments(filtered);
  };

  const handleApprovalAction = (payment: any, action: "approve" | "reject") => {
    if (action === "approve") {
      // Show simple confirmation for approve
      Swal.fire({
        title: "Approve Payment",
        text: `Are you sure you want to approve payment ${payment.raBillPaymentSequenceId}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes, Approve",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            setActionLoading(true);

            // Call the approval API
            const response: any = await paymentsApis.approvalAction({
              raBillPaymentId: payment.raBillPaymentId || payment.id,
              action: "Approved",
              // reason: "Payment approved" // Default approval message
            });

            if (response.status) {
              Swal.fire("Success!", "Payment approved successfully", "success");

              // Remove from pending list and refresh data
              setPayments((prev) => prev.filter((p) => p.id !== payment.id));
              setRefreshToggle(!refreshToggle);
            } else {
              throw new Error(response.message || "Failed to approve payment");
            }
          } catch (error: any) {
            console.error("Error approving payment:", error);
            Swal.fire(
              "Error!",
              error.message || "Failed to approve payment",
              "error"
            );
          } finally {
            setActionLoading(false);
          }
        }
      });
    } else {
      // For reject, show the modal with comments field
      setSelectedPayment(payment);
      setApprovalAction(action);
      setApprovalComments("");
      setShowApprovalModal(true);
    }
  };

  const processApproval = async () => {
    if (!selectedPayment) return;

    if (approvalAction === "reject" && !approvalComments.trim()) {
      Swal.fire("Warning", "Please provide rejection comments", "warning");
      return;
    }

    try {
      setActionLoading(true);

      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1500));

      // Update payment status
      const updatedPayments = payments?.map((payment) => {
        if (payment.id === selectedPayment.id) {
          const newStatus = getNextStatus(payment.status, approvalAction);
          return {
            ...payment,
            status: newStatus,
            approvalHistory: [
              ...payment.approvalHistory,
              {
                action: approvalAction === "approve" ? "Approved" : "Rejected",
                actionBy: "current.user@company.com", // Mock current user
                actionDate: dayjs().toISOString(),
                role: currentUserRole,
                comments: approvalComments || undefined,
                status: newStatus,
              },
            ],
          };
        }
        return payment;
      });

      setPayments(updatedPayments.filter((p) => p.id !== selectedPayment.id)); // Remove from pending list
      setShowApprovalModal(false);

      Swal.fire(
        "Success!",
        `Payment has been ${
          approvalAction === "approve" ? "approved" : "rejected"
        } successfully`,
        "success"
      );
    } catch (error) {
      console.error("Error processing approval:", error);
      Swal.fire("Error!", "Failed to process approval", "error");
    } finally {
      setActionLoading(false);
    }
  };

  const getNextStatus = (
    currentStatus: PaymentStatus,
    action: "approve" | "reject"
  ): PaymentStatus => {
    if (action === "reject") return PaymentStatus.Rejected;

    const statusFlow: Partial<Record<PaymentStatus, PaymentStatus>> = {
      [PaymentStatus.Submitted]: PaymentStatus.Checked,
      [PaymentStatus.Checked]: PaymentStatus.Verified,
      [PaymentStatus.Verified]: PaymentStatus.Approved,
    };

    return statusFlow[currentStatus] || currentStatus;
  };

  const getRoleDisplayName = (role: UserRole): string => {
    const roleNames = {
      [UserRole.Maker]: "Maker",
      [UserRole.Checker]: "Checker",
      [UserRole.Verifier]: "Verifier",
      [UserRole.Approver]: "Approver",
      [UserRole.Finance]: "Finance",
    };
    return roleNames[role] || role;
  };

  const getStatusColor = (status: PaymentStatus): string => {
    const colors: Record<PaymentStatus, string> = {
      [PaymentStatus.Draft]: "default",
      [PaymentStatus.Submitted]: "processing",
      [PaymentStatus.Checked]: "warning",
      [PaymentStatus.Verified]: "orange",
      [PaymentStatus.Approved]: "success",
      [PaymentStatus.Posted]: "cyan",
      [PaymentStatus.Paid]: "green",
      [PaymentStatus.Rejected]: "error",
      [PaymentStatus.Returned]: "purple",
    };
    return colors[status] || "default";
  };

  const handleViewPayment = async (payment: any) => {
    try {
      setLoading(true);

      // Call the paymentById API with the raBillPaymentId
      const response: any = await paymentsApis.paymentById(
        payment.raBillPaymentId
      );

      console.log("Payment details response:", response);

      const { data, status, message } = response;

      if (status) {
        // Process the API response and map it to the expected payment structure
        const processedPayment = {
          ...payment,
          // Map API response fields to payment object
          paymentVoucherNumber: data.raBillPaymentSequenceId,
          paymentDate: data.paymentDate,
          paymentType: data.paymentType,
          status: data.status,
          contractorName: data.contractorName,
          siteName: data.siteName,
          paymentMethod: data.paymentMethod,
          bankAccountNumber: data.bankAccountNumber,
          bankName: data.bankName,
          totalPaymentAmount: data.totalPaymentAmount,
          paidAmount: data.paidAmount,
          netPayableAmount: data.netPayableAmount,
          tdsSection: data.tdsSection,
          tdsRate: data.tdsRate,
          tdsDeducted: data.tdsDeducted,
          otherDeductions: data.otherDeductions,
          utrReference: data.utrNumber,
          narration: data.narration,
          remarks: data.remarks,

          // Process payment lines (allocations)
          allocations:
            data.raBillPaymentLines?.map((line: any) => ({
              id: line.raBillPaymentLineId,
              raBillId: line.raBillId,
              raBillNumber: line.raBillSequenceId,
              workOrderId: line.workOrderId,
              workOrderNumber: line.workOrderSequenceId || line.workOrderNumber,
              thisPaymentAmount: line.paidAmount,
              resultingStatus: line.status,
            })) || [],

          // Process approval history
          approvalHistory:
            data.paymentApprovals?.map((approval: any) => ({
              action:
                approval.status === "Approved"
                  ? "Approved"
                  : approval.status === "Rejected"
                  ? "Rejected"
                  : "Pending",
              actionBy: approval.approvedByName || approval.approverName,
              actionDate: approval.approvalDate || approval.createdAt,
              role: approval.approvalStage,
              status: approval.status,
              comments: approval.reason,
              level: approval.level,
            })) || [],

          // Process attachments/documents
          attachments: data.dms || [],

          // Additional details
          createdBy: data.createdByName,
          createdAt: data.createdAt,
          processedBy: data.processedByName,
          processedAt: data.processedAt,
          approvedBy: data.approvedByName,
          approvedAt: data.approvedAt,
        };

        setSelectedPayment(processedPayment);
        setShowDetailsModal(true);
      } else {
        Swal.fire(
          "Error!",
          message || "Failed to fetch payment details",
          "error"
        );
      }
    } catch (error: any) {
      console.error("Error fetching payment details:", error);
      Swal.fire(
        "Error!",
        "Failed to fetch payment details. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // Enhanced columns for new payment approvals
  const enhancedColumns: TableColumnsType<PaymentData> = [
    // {
    //   title: "#",
    //   key: "#",
    //   width: 50,
    //   render: (_: any, __: any, index: number) => index + 1,
    // },
    {
      title: "Payment Voucher",
      dataIndex: "raBillPaymentSequenceId",
      key: "raBillPaymentSequenceId",
      width: 230,
      render: (text: string) => (
        <div className="fw-bold text-primary">{text}</div>
      ),
    },
    {
      title: "Contractor",
      key: "contractor",
      width: 200,
      render: (record: PaymentData) => (
        <div>
          <div className="fw-bold">{record.contractorName}</div>
          <small className="text-muted">{record.siteName}</small>
        </div>
      ),
    },
    {
      title: "Payment Date",
      dataIndex: "paymentDate",
      key: "paymentDate",
      width: 120,
      render: (date: string) => dayjs(date).format("DD-MMM-YYYY"),
    },
    {
      title: "Submitted",
      key: "submitted",
      width: 120,
      render: (record: PaymentData) => (
        <div>
          <div>{dayjs(record.submittedAt).format("DD-MMM-YYYY")}</div>
          <small className="text-muted">{record.submittedBy}</small>
        </div>
      ),
    },
    {
      title: "Net Amount",
      dataIndex: "paidAmount",
      key: "paidAmount",
      width: 120,
      render: (amount: number) => (
        <div className="fw-bold text-success">₹{amount?.toLocaleString()}</div>
      ),
    },
    {
      title: "UTR Reference",
      dataIndex: "utrNumber",
      key: "utrNumber",
      width: 200,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 180,
      render: (status: PaymentStatus) => (
        <Tag color={getStatusColor(status)}>{status}</Tag>
      ),
    },
    // {
    //   title: "RA Bills",
    //   key: "raBills",
    //   width: 80,
    //   render: (record: PaymentData) => (
    //     <span className="badge badge-dim badge-blue">
    //       {record.allocations?.length}
    //     </span>
    //   ),
    // },
    {
      title: "Actions",
      key: "actions",
      width: 160,
      fixed: "right",
      render: (record: PaymentData) => (
        <Space>
          <Tooltip title="View Details">
            <AntButton
              type="text"
              icon={<EyeOutlined />}
              onClick={() => handleViewPayment(record)}
            />
          </Tooltip>
          <Tooltip title="Approve">
            <AntButton
              type="text"
              icon={<CheckOutlined />}
              className="text-success"
              onClick={() => handleApprovalAction(record, "approve")}
            />
          </Tooltip>
          <Tooltip title="Reject">
            <AntButton
              type="text"
              icon={<CloseOutlined />}
              danger
              onClick={() => handleApprovalAction(record, "reject")}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const drawerColumns: any = [
    {
      title: "#",
      key: "#",
      width: 50,
      fixed: "left",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Invoice #",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      width: 120,
      fixed: "left",
      render: (text: any) => (
        <div className="align-left">
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date: any) => <span>{FormatDate(date)}</span>,
      width: 170,
    },
    {
      title: "Supplier",
      dataIndex: "supplierName",
      key: "supplierName",
      width: 200,
    },
    {
      title: "Payable Amount",
      dataIndex: "payableAmount",
      key: "payableAmount",
      width: 140,
      render: (text: any, record: any) => {
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {formatCurrency(Number(text), "INR")}
              {/* <Tooltip title={formatCurrency(Number(text), "INR")}>
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip> */}
            </span>
          </div>
        );
      },
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
  ];

  const approvePayment = async () => {
    // try {
    //   const res: any = await paymentApis.approvalAction(
    //     drawerData?.paymentNumber
    //   );
    //   const { status, message } = res;
    //   if (status) {
    //     Swal.fire("Success", message, "success");
    //     // fetchData();
    //     setRefreshToggle(!refreshToggle);
    //   }
    // } catch (error) {}
    // setDisableAccept(true);
  };

  const disapprovePayment = async (reason: any) => {
    // try {
    //   const res: any = await paymentApis.approvalAction({
    //     raBillPaymentId: drawerData?.paymentNumber,
    //     action: "Rejected",
    //     reason: reason,
    //   });
    //   const { status, message } = res;
    //   if (status) {
    //     Swal.fire("Success", message, "success");
    //     // fetchData();
    //     setRefreshToggle(!refreshToggle);
    //   }
    // } catch (error) {}
    // setDisableReject(false);
  };

  const { Search } = Input;
  const { RangePicker } = DatePicker;

  return (
    <>
      <TransactionFlowDefaultTemplate
        moduleKey="view-payments-pending"
        title="All Payments"
        columns={enhancedColumns} // Use enhanced columns
        loading={loading}
        sideNavigation={
          <div
            className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
              sm ? "content-active" : ""
            }`}
          >
            <PaymentsAside updateSm={setSm} sm={sm} />
          </div>
        }
        extra={{
          tableScrollX: 1200,
        }}
      />

      {/* Payment Details Modal */}
      <Modal
        title={
          <div className="d-flex align-items-center">
            <FileTextOutlined className="mr-2" />
            Payment Details - {selectedPayment?.paymentVoucherNumber}
          </div>
        }
        open={showDetailsModal}
        onCancel={() => setShowDetailsModal(false)}
        width={1500}
        footer={[
          <AntButton key="close" onClick={() => setShowDetailsModal(false)}>
            Close
          </AntButton>,
        ].filter(Boolean)}
      >
        {selectedPayment && (
          <div>
            <Row gutter={[24, 24]}>
              <Col span={20}>
                <Descriptions bordered size="small" column={2}>
                  <Descriptions.Item label="Payment Voucher">
                    {selectedPayment.paymentVoucherNumber}
                  </Descriptions.Item>
                  <Descriptions.Item label="Payment Date">
                    {dayjs(selectedPayment.paymentDate).format("DD/MM/YYYY")}
                  </Descriptions.Item>
                  <Descriptions.Item label="Payment Type">
                    {selectedPayment.paymentType}
                  </Descriptions.Item>
                  <Descriptions.Item label="Status">
                    <Tag color={getStatusColor(selectedPayment.status)}>
                      {selectedPayment.status}
                    </Tag>
                  </Descriptions.Item>
                  <Descriptions.Item label="Contractor">
                    {selectedPayment.contractorName}
                  </Descriptions.Item>
                  <Descriptions.Item label="Site">
                    {selectedPayment.siteName}
                  </Descriptions.Item>
                  <Descriptions.Item label="Legal Entity">
                    {selectedPayment.legalEntityName}
                  </Descriptions.Item>
                  <Descriptions.Item label="Payment Method">
                    {selectedPayment.paymentMethod}
                  </Descriptions.Item>
                  <Descriptions.Item label="Bank Account">
                    {selectedPayment.bankAccountNumber &&
                    selectedPayment.bankName
                      ? `${selectedPayment.bankAccountNumber} - ${selectedPayment.bankName}`
                      : selectedPayment.bankAccountName || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="TDS Section">
                    {selectedPayment.tdsSection} ({selectedPayment.tdsRate}%)
                  </Descriptions.Item>
                  <Descriptions.Item label="TDS Deducted">
                    ₹{selectedPayment.tdsDeducted?.toLocaleString() || "0"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Other Deductions">
                    ₹{selectedPayment.otherDeductions?.toLocaleString() || "0"}
                  </Descriptions.Item>
                  {selectedPayment.utrReference && (
                    <Descriptions.Item label="UTR Reference" span={2}>
                      <code>{selectedPayment.utrReference}</code>
                    </Descriptions.Item>
                  )}
                  <Descriptions.Item label="Narration" span={2}>
                    {selectedPayment.narration || "No narration provided"}
                  </Descriptions.Item>
                  {selectedPayment.remarks && (
                    <Descriptions.Item label="Remarks" span={2}>
                      {selectedPayment.remarks}
                    </Descriptions.Item>
                  )}
                  <Descriptions.Item label="Created By">
                    {selectedPayment.createdBy}
                  </Descriptions.Item>
                  <Descriptions.Item label="Created At">
                    {selectedPayment.createdAt
                      ? dayjs(selectedPayment.createdAt).format(
                          "DD/MM/YYYY HH:mm"
                        )
                      : "N/A"}
                  </Descriptions.Item>
                </Descriptions>
              </Col>
              <Col span={4}>
                <Card>
                  <Statistic
                    title="Net Payable Amount"
                    value={
                      selectedPayment.netPayableAmount ||
                      selectedPayment.netPayable
                    }
                    precision={2}
                    prefix="₹"
                    valueStyle={{ color: "#3f8600" }}
                  />
                  <Divider />
                  <div className="d-flex justify-content-between">
                    <span>Total Payment Amount:</span>
                    <strong>
                      ₹{selectedPayment.totalPaymentAmount?.toLocaleString()}
                    </strong>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Paid Amount:</span>
                    <strong>
                      ₹{selectedPayment.paidAmount?.toLocaleString()}
                    </strong>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>TDS Deducted:</span>
                    <strong className="text-warning">
                      -₹{selectedPayment.tdsDeducted?.toLocaleString() || "0"}
                    </strong>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Other Deductions:</span>
                    <strong>
                      -₹
                      {selectedPayment.otherDeductions?.toLocaleString() || "0"}
                    </strong>
                  </div>
                </Card>
              </Col>
            </Row>

            <Divider />

            <h6>
              Payment Allocations ({selectedPayment?.allocations?.length})
            </h6>
            <Table
              columns={[
                {
                  title: "RA Bill Number",
                  dataIndex: "raBillNumber",
                  key: "raBillNumber",
                  width: 140,
                },
                {
                  title: "Work Order",
                  dataIndex: "workOrderNumber",
                  key: "workOrderNumber",
                  width: 140,
                },
                {
                  title: "RA Period",
                  dataIndex: "raPeriod",
                  key: "raPeriod",
                  width: 100,
                  render: (data, record: any) =>
                    `${data?.startDate} to ${data?.endDate}`,
                },
                {
                  title: "Bill Value",
                  dataIndex: "raBillValue",
                  key: "raBillValue",
                  width: 120,
                  render: (amount: number) => `₹${amount?.toLocaleString()}`,
                },
                {
                  title: "Already Paid",
                  dataIndex: "alreadyPaid",
                  key: "alreadyPaid",
                  width: 120,
                  render: (amount: number) => `₹${amount?.toLocaleString()}`,
                },
                {
                  title: "This Payment",
                  dataIndex: "thisPaymentAmount",
                  key: "thisPaymentAmount",
                  width: 120,
                  render: (amount: number) => `₹${amount?.toLocaleString()}`,
                },
                {
                  title: "Resulting Status",
                  dataIndex: "resultingStatus",
                  key: "resultingStatus",
                  width: 120,
                  render: (status: string) => {
                    const color =
                      status === "Paid"
                        ? "green"
                        : status === "Partially Paid"
                        ? "orange"
                        : "red";
                    return <Tag color={color}>{status}</Tag>;
                  },
                },
              ]}
              dataSource={selectedPayment.allocations}
              rowKey="id"
              size="small"
              pagination={false}
              scroll={{ x: 800 }}
            />

            <Divider />

            {/* Attachments Section */}
            {selectedPayment.attachments &&
              selectedPayment.attachments?.length > 0 && (
                <>
                  <h6>
                    Supporting Documents ({selectedPayment.attachments?.length})
                  </h6>
                  <div style={{ marginBottom: 16 }}>
                    {selectedPayment.attachments?.map(
                      (attachment: any, index: number) => (
                        <Card
                          key={index}
                          size="small"
                          style={{ marginBottom: 8 }}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <FileTextOutlined className="mr-2" />
                              <strong>
                                {attachment.fileName ||
                                  attachment.originalFileName ||
                                  `Document ${index + 1}`}
                              </strong>
                              {attachment.fileSize && (
                                <span className="text-muted ml-2">
                                  ({(attachment.fileSize / 1024).toFixed(1)} KB)
                                </span>
                              )}
                            </div>
                            <div>
                              {attachment.uploadDate && (
                                <span className="text-muted mr-2">
                                  {dayjs(attachment.uploadDate).format(
                                    "DD/MM/YYYY"
                                  )}
                                </span>
                              )}
                              {attachment.fileUrl && (
                                <AntButton
                                  size="small"
                                  type="link"
                                  icon={<EyeOutlined />}
                                  onClick={() =>
                                    window.open(attachment.fileUrl, "_blank")
                                  }
                                >
                                  View
                                </AntButton>
                              )}
                            </div>
                          </div>
                        </Card>
                      )
                    )}
                  </div>
                  <Divider />
                </>
              )}

            <h6>Approval History</h6>
            <Timeline>
              {selectedPayment?.approvalHistory?.map(
                (history: any, index: any) => (
                  <Timeline.Item
                    key={index}
                    color={
                      history.status === PaymentStatus.Rejected ? "red" : "blue"
                    }
                  >
                    <div>
                      <strong>{history.action}</strong> by {history.actionBy}
                      <div className="text-muted small">
                        {dayjs(history.actionDate).format("DD/MM/YYYY HH:mm")} |{" "}
                        {history.role}
                      </div>
                      {history.comments && (
                        <div className="mt-1 p-2 bg-light rounded">
                          <small>{history.comments}</small>
                        </div>
                      )}
                    </div>
                  </Timeline.Item>
                )
              )}
            </Timeline>
          </div>
        )}
      </Modal>

      {/* Approval Action Modal */}
      <Modal
        title={
          <div className="d-flex align-items-center">
            {approvalAction === "approve" ? (
              <CheckOutlined className="text-success mr-2" />
            ) : (
              <CloseOutlined className="text-danger mr-2" />
            )}
            {approvalAction === "approve"
              ? "Approve Payment"
              : "Reject Payment"}
          </div>
        }
        open={showApprovalModal}
        onCancel={() => setShowApprovalModal(false)}
        footer={[
          <AntButton key="cancel" onClick={() => setShowApprovalModal(false)}>
            Cancel
          </AntButton>,
          <AntButton
            key="confirm"
            type="primary"
            danger={approvalAction === "reject"}
            loading={actionLoading}
            onClick={processApproval}
          >
            {actionLoading ? <Spinner size="sm" /> : null}
            {approvalAction === "approve" ? "Approve" : "Reject"}
          </AntButton>,
        ]}
      >
        {selectedPayment && (
          <div>
            <div className="mt-3">
              <label className="form-label">
                Comments{" "}
                {approvalAction === "reject" && (
                  <span className="text-danger">*</span>
                )}
              </label>
              <Input.TextArea
                rows={3}
                placeholder={`Enter ${
                  approvalAction === "approve" ? "approval" : "rejection"
                } comments...`}
                value={approvalComments}
                onChange={(e) => setApprovalComments(e.target.value)}
              />
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default PendingPaymentApprovals;
